import React, { useState, useCallback } from "react"
import Box from "@mui/material/Box"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import IconButton from "@mui/material/IconButton"
import CloseRoundedIcon from "@mui/icons-material/CloseRounded"
import AppAppBar from "@/features/landing/template/components/AppAppBar"
import Hero from "@/features/landing/template/components/Hero"
import HowToUse from "@/features/landing/template/components/HowToUse"
import LogoCollection from "@/features/landing/template/components/LogoCollection"
import Features from "@/features/landing/template/components/Features"
import Highlights from "@/features/landing/template/components/Highlights"
import Pricing from "@/features/landing/template/components/Pricing"
import FAQ from "@/features/landing/template/components/FAQ"
import Footer from "@/features/landing/template/components/Footer"
import Login from "@/features/landing/components/login"
import SignUp from "@/features/landing/components/sign-up"

type AuthView = "login" | "signup"

const LandingPage: React.FC = () => {
  const [authView, setAuthView] = useState<AuthView>("login")
  const [authOpen, setAuthOpen] = useState(false)

  const openSignIn = useCallback(() => {
    setAuthView("login")
    setAuthOpen(true)
  }, [])

  const openSignUp = useCallback(() => {
    setAuthView("signup")
    setAuthOpen(true)
  }, [])

  const closeAuth = useCallback(() => {
    setAuthOpen(false)
  }, [])

  return (
    <Box sx={{ overflowX: "hidden", width: "100vw" }}>
      <AppAppBar onSignIn={openSignIn} onSignUp={openSignUp} />

      <Box component="main">
        <Hero onGetStarted={openSignUp} />
        <HowToUse />
        <LogoCollection />
        <Features />
        {/* <Testimonials /> */}
        <Highlights />
        <Pricing />
        <FAQ />
        <Footer />
      </Box>

      {/* Auth dialog — sign in / sign up */}
      <Dialog open={authOpen} onClose={closeAuth} maxWidth="xs" fullWidth aria-labelledby="auth-dialog-title">
        <DialogContent sx={{ position: "relative", pt: 4 }}>
          <IconButton
            aria-label="close"
            onClick={closeAuth}
            size="small"
            sx={{ position: "absolute", top: 8, right: 8 }}>
            <CloseRoundedIcon fontSize="small" />
          </IconButton>

          {authView === "login" ? (
            <Login onToggleSignUp={() => setAuthView("signup")} />
          ) : (
            <SignUp onToggleSignUp={() => setAuthView("login")} />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  )
}

export default LandingPage
